import React, { useState } from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Button } from "rbx";
import { BooleanInput, SystemCodeSelect } from "../../../components/inputs";

const INITIAL_FILTER_STATE = {
  Active: true
};
function GLMainAccountFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const newFilters = {
      ...inputs
    };
    if (e.target.name === "TypeRecIdRef") {
      const v = parseInt(value);
      newFilters.TypeRecIdRef = v !== 0 ? v : null;
    } else {
      newFilters[e.target.name] = value;
    }
    setInputs({ ...newFilters });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <div style={{ minWidth: 300 }}>
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <SystemCodeSelect
                icon="globe"
                label="Account Type"
                lookup={{ Category: "General Ledger", Code: "AcctType" }}
                name="TypeRecIdRef"
                value={inputs?.TypeRecIdRef}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Active</Label>
              <BooleanInput
                name="Active"
                value={inputs?.Active}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <hr />
      <Field kind="group">
        <Control>
          <Button color="primary" onClick={handleClose}>
            OK
          </Button>
        </Control>
        <Control>
          <Button onClick={handleReset}>Reset</Button>
        </Control>
      </Field>
    </div>
  );
}
GLMainAccountFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default GLMainAccountFilters;
